import { render, staticRenderFns } from "./surface_post_being_edited.vue?vue&type=template&id=a25b1d84&scoped=true&"
import script from "./surface_post_being_edited.vue?vue&type=script&lang=js&"
export * from "./surface_post_being_edited.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_being_edited.vue?vue&type=style&index=0&id=a25b1d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25b1d84",
  null
  
)

export default component.exports